import { MessageCircle, Phone } from "lucide-react";
import { PHONE_TEL, WHATSAPP_URL } from "../data/site";

export default function FloatingCTAs() {
  return (
    <div
      data-testid="floating-ctas"
      className="fixed bottom-5 right-5 z-50 flex flex-col gap-3"
    >
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noreferrer"
        aria-label="WhatsApp"
        data-testid="float-whatsapp-btn"
        className="h-12 w-12 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-105 transition-transform"
      >
        <MessageCircle className="h-5 w-5" />
      </a>
      <a
        href={PHONE_TEL}
        aria-label="Call"
        data-testid="float-call-btn"
        className="h-12 w-12 rounded-full bg-[#0370AD] text-white flex items-center justify-center shadow-lg hover:scale-105 transition-transform"
      >
        <Phone className="h-5 w-5" />
      </a>
    </div>
  );
}
